module.exports = __webpack_public_path__ + "static/flags/RI-c106b7bd4548f2bce9e7a42732c15677.gif";